import React from 'react'
import {CircularProgress} from '@material-ui/core'

const Loader = () =>
  <div style={{marginTop: '180px', display: 'flex', justifyContent: 'center'}}><CircularProgress
    size={100}/>
  </div>

export default Loader
